import { setPendingChunkErrorHandler } from 'utils/reloadOnChunkLoadError';

declare const __DOOM_CHUNK__: string | undefined;

let failures = 0;

export async function loadDoom(): Promise<typeof import('./doom')> {
  const file =
    typeof __DOOM_CHUNK__ === 'undefined' ? undefined : __DOOM_CHUNK__;
  // The optional game reports its own download failure instead of spending
  // the application's one automatic reload.
  const onPreloadError = (event: Event) => {
    const message =
      (event as Event & { payload?: { message?: string } }).payload?.message ??
      '';
    const namesFile =
      /(?:https?:\/\/|\/)[^\s'")]+|[\w.-]+\.m?js(?:[?#][^\s'")]*)?/i.test(
        message,
      );
    if ((file && message.includes(file)) || !namesFile) event.preventDefault();
  };
  window.addEventListener('vite:preloadError', onPreloadError, true);
  setPendingChunkErrorHandler(onPreloadError);
  try {
    // A failed dynamic import stays failed for its specifier, so a retry
    // asks for the same chunk under a fresh query string, as loadGame does.
    const script = document.querySelector<HTMLScriptElement>(
      'script[type="module"][src]',
    );
    const retryUrl =
      failures && file && script ? new URL(file, script.src) : null;
    if (retryUrl) retryUrl.searchParams.set('retry', String(failures));
    return retryUrl
      ? await import(/* @vite-ignore */ retryUrl.href)
      : await import('./doom');
  } catch (error) {
    failures += 1;
    throw error;
  } finally {
    setPendingChunkErrorHandler();
    window.removeEventListener('vite:preloadError', onPreloadError, true);
  }
}
